import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ENGINE_NOTIFICATION_SERVICE, EngineNotificationService } from './services/engine-nofitication.service';

export function provideNotification(): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: ENGINE_NOTIFICATION_SERVICE, useClass: EngineNotificationService }]);
}
